import { z } from "zod";

export const versionResponseSchema = z.object({
  timestamp: z.number(),
  version: z.string(),
  build: z.string(),
  shortSha: z.string(),
  tag: z.string(),
});

export type VersionResponse = z.infer<typeof versionResponseSchema>;
